import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = localStorage.getItem('admin_token');

  // Add Authorization header if token exists
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401/403 errors - redirect to login
      if (error.status === 401 || error.status === 403) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
